const DEFAULT_BACKEND_URL = process.env.NODE_ENV === 'development'
  ? 'http://localhost:8000'
  : '';
const RAW_BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || DEFAULT_BACKEND_URL).trim();

const runningInBrowser = typeof window !== 'undefined';
const currentHostname = runningInBrowser ? window.location.hostname : '';
const isLocalFrontendHost = currentHostname === 'localhost' || currentHostname === '127.0.0.1';
const envPointsToLocalhost = /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?(\/|$)/i.test(RAW_BACKEND_URL);

// In deployed frontend, ignore localhost backend URLs and fall back to same-origin `/api`.
const EFFECTIVE_BACKEND_URL = (!isLocalFrontendHost && envPointsToLocalhost) ? '' : RAW_BACKEND_URL;
const NORMALIZED_BACKEND_URL = EFFECTIVE_BACKEND_URL.replace(/\/+$/, '');
export const BACKEND_ORIGIN = NORMALIZED_BACKEND_URL.replace(/\/api$/, '');

export const API_BASE = BACKEND_ORIGIN ? `${BACKEND_ORIGIN}/api` : '/api';
export const ADMIN_BASE = `${API_BASE}/admin`;
